function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import BackButton from './BackButton';
import Link from './Link';
import useNavigateBackHandler from './useNavigateBackHandler';

function BackArrowLink({
  to,
  ...props
}) {
  return React.createElement(Link, {
    to: to,
    onClick: useNavigateBackHandler(to)
  }, ({
    active: _,
    ...linkProps
  }) => React.createElement(BackButton, _extends({}, props, linkProps)));
}

export default BackArrowLink;